<template>
  <dol-select
    :value="value"
    source="server"
    server-type="DotNet"
    dot-net-table-name="GM_CITY"
    :label-field="$kt('CITY_NAME')"
    key-field="CITY_ID"
    value-field="CITY_ID"
    :query-data="queryData"
    @input="inputValue"
    @change="changeValue"
  />
</template>

<script>
export default {
  name: 'city-select',
  props: {
    value: {},
    queryData: {type: Object},
  },
  data () {
    return {
    };
  },
  computed: {
  },
  methods: {
    inputValue(v){
      this.$emit('input', v);
    },
    changeValue(v, o){
      this.$emit('change', v, o);
    }
  }
};
</script>

<style lang="scss">

</style>
